export function getBizDomain( domain ) {
    var domainList = ( domain || document.domain ).split( '.' );
    if( domainList.length > 2 ){
        domainList.shift();
    }
    return domainList.join( '.' )
}
